

/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import apiConfig from "../config/apiConfig";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import "../assets/css/nucleo-icons.css";
function Login(props) {
  const serverUrl = apiConfig.serverUrl;
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleLogin = (e) => {
    e.preventDefault();
 

    
        const formData = new FormData();
       
          formData.append('email', email);
          formData.append('password', password);
         
          axios.post(serverUrl + 'login-management-panel', formData)
          .then(response => {
              if (response.status === 200) {
                  toast.success('ورود موفقیت‌آمیز بود!');
                  localStorage.setItem('email', response.data.email);
                  navigate('/rtl/rtl-dashboard');
              }
          })
          .catch(error => {
              if (error.response) {
                  // بررسی خطای 401 (Unauthorized)
                  if (error.response.status === 401) {
                      toast.error('نام کاربری یا رمز عبور اشتباه است');
                  } else {
                      // نمایش پیام خطا برای سایر وضعیت‌ها
                      toast.error('خطایی رخ داده است');
                  }
              } else {
                  console.error('Error:', error);
                  toast.error('خطایی در اتصال به سرور رخ داد');
              }
          });
  };
  return (
    <>
      <div className="content">
      <ToastContainer /> 
      <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2 style={{fontSize:'18px'}}>ورود به پنل رژیم غذایی آریایی</h2>
        <div className="input-group">
          <label>ایمیل</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label>رمز عبور</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">ورود</button>
        
      </form>
    </div>
      </div>
    </>
  );
}

export default Login;